import React from 'react';
import { createDOMFrameScheduler, Paintable, Pipeline } from 'ff-canvas';
import { createPipeline } from './createPipeline';
import { createTransform, TransformParameters } from '@gift/common/helpers/transformParameters';
import { Size } from '@gift/types/generic/Size';

export type Engine2d = {
    pipeline: Pipeline,
    requestRender: () => void,
    is: (size: Size, parameters: TransformParameters) => boolean
};

export const createEngine2d = (
    paintables: React.MutableRefObject<Paintable[]>,
    canvas: HTMLCanvasElement,
    pxSize: Size,
    parameters: TransformParameters,
    options?: { onRender?: (imageUrl: string) => Promise<void> }
): Engine2d => {

    const requestRender = createDOMFrameScheduler(async () => {
        pipeline.clear(undefined);
        pipeline.paintAll(paintables.current!);
        if (options?.onRender) {
            await options.onRender(canvas.toDataURL());
        }
    });

    canvas.width = pxSize.width;
    canvas.height = pxSize.height;

    canvas.style.width = pxSize.width + 'px';
    canvas.style.height = pxSize.height + 'px';

    const transform = createTransform(pxSize.width, pxSize.height, parameters);
    const pipeline = createPipeline(canvas, {
        requestRender,
        transform: transform,
        useDevicePixelRatio: true
    });

    return {

        pipeline,
        requestRender,

        is: (newPxSize, newParameters) => {

            const transformParameterKeys: (keyof TransformParameters)[] = [
                'sceneWidth', 'sceneHeight',
                'variantViewboxX', 'variantViewboxY',
                'variantViewboxWidth', 'variantViewboxHeight',
                'designViewboxWidth', 'designViewboxHeight'
            ];

            return transformParameterKeys.every(key => newParameters[key] === parameters[key])
                && newPxSize.width === pxSize.width
                && newPxSize.height === pxSize.height;
        }
    };
};